'use strict';
import classNames from 'classnames';
import isString from 'lodash/isString';
import isBoolean from 'lodash/isBoolean';
import isNumber from 'lodash/isNumber';
import isUndefined from 'lodash/isUndefined';
import * as T from 'prop-types';
import React, {Component} from 'react';


export class DropdownOptionComponent extends Component {
  static propTypes = {
    className: T.string,
    model: T.any.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(ev) {
    ev.stopPropagation();

    const model = this.props.model;
    const value = isUndefined(model.value) ? model.label : model.value;
    const label = model.label || model.value || model;
    this.props.onClick(ev, {value, label});
  }

  render() {
    const model = this.props.model;
    const label = getDisplayValue(model);

    return (
      <div
        className={classNames(this.props.className, model.className)}
        onClick={this.handleClick}
      >
        {label}
      </div>
    );
  }
}

export function getDisplayValue(model) {
  if (isRenderable(model.label)) {
    return model.label;
  } else if (isRenderable(model.value)) {
    return model.value;
  } else if (isRenderable(model)) {
    return model;
  } else {
    return '';
  }
}

function isRenderable(item) {
  return isString(item) || isNumber(item) || isBoolean(item);
}



// WEBPACK FOOTER //
// ./src/js/components/Dropdown/DropdownOption/DropdownOptionComponent.js